import React, { memo, forwardRef } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Table from '../../Controls/Table'

const TableContainer = styled.div`
  padding: 20px;
`

const ReportsTable = memo(forwardRef((props, ref) => {
  return (
    < TableContainer >
      <Table
        tableRef={props?.tableRef}
        columns={props?.columns}
        getPageData={props?.getData}
        rowsPerPageOptions={[30]}
        exportButton={false}
        paging={true}
        draggable={false}
        isCellEditDisabled={true}
        search={false}
        toolbar={true}
        selection={false}
        refresh={props?.refresh}
        reportsTable={props?.reports}
        reportFor={props?.reportFor || false}
      />
    </TableContainer >
  )
}
))

export default ReportsTable

ReportsTable.propTypes = {
  columns: PropTypes.array,
  tableRef: PropTypes.oneOfType([
    PropTypes.func, 
    // Or a ref object (see the note about SSR)
    PropTypes.shape({ current: PropTypes.any })
  ]),
  getData: PropTypes.func,
  refresh: PropTypes.bool,
  reports: PropTypes.objectOf({
    status: PropTypes.bool,
    isEmployeeLevel: PropTypes.bool,
  }),
  reportFor: PropTypes.any,
}